/**
 * @author      yonatek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IconProps } from '../../types'

export const PhoneCall = ({ size = 20, stroke }: IconProps) => {
  stroke = stroke ?? '#0D2A3A'

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.088 9.04427C17.158 5.87427 14.638 3.25427 11.468 3.19427"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.398 6.62427C12.678 6.65427 13.688 7.70427 13.668 8.98427"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.378 14.7043C16.308 14.5343 16.208 14.3743 16.048 14.2443L14.148 12.7443C13.698 12.3843 13.058 12.4143 12.648 12.8143L11.308 14.1043C11.058 14.3443 10.678 14.4243 10.358 14.2743C9.44798 13.8343 8.58798 13.2343 7.83798 12.4543C7.08798 11.6743 6.52798 10.7943 6.12798 9.86425C5.98798 9.54425 6.08798 9.16425 6.33798 8.92425L7.67798 7.63425C8.08798 7.24425 8.14798 6.59425 7.80798 6.13425L6.38798 4.18425C6.26798 4.01425 6.10798 3.90425 5.93798 3.83425C5.52798 3.64425 5.02798 3.69425 4.66798 4.03425L3.90798 4.76425C1.82798 6.76425 2.69798 11.0543 5.86798 14.3343C9.02798 17.6343 13.278 18.6743 15.368 16.6743L16.128 15.9443C16.488 15.6043 16.548 15.1043 16.378 14.6843V14.7043Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
